import Canvg from 'canvg'
import { logger } from 'utils'

import { BlobDataURLType, CertificateType } from '../certificate.types'

import { getHackathonCertificateSVGString } from './getHackathon'
import { getQRCodeSVGString } from './qrCode'

const ErrorMessage =
  'Oops! There is some problem in generating certificate! Please try again later or contact at support@devsnest.in'

export const getCertificate = async (
  name: string,
  uuid: string,
  type: CertificateType
) => {
  try {
    const {
      certificate_sub_title,
      before_name,
      after_name_1,
      after_name_2,
      after_name_3
    } = getFieldsByCertificateType(type)

    const hackathonCertificateSVGString: string =
      getHackathonCertificateSVGString(
        certificate_sub_title,
        before_name,
        name,
        after_name_1,
        after_name_2,
        after_name_3,
        uuid,
        getQRCodeSVGString(`${window.location.href}`)
      )
    return await getCertificateBlobAndDataURL(hackathonCertificateSVGString)
  } catch (error) {
    logger('Error in certificates', error)
    throw new TypeError(ErrorMessage)
  }
}

export const getFieldsByCertificateType = (
  certificate_type: CertificateType
) => {
  const data = {
    certificate_sub_title: '',
    before_name: '',
    after_name_1: '',
    after_name_2: '',
    after_name_3: ''
  }

  if (certificate_type.startsWith('course_')) {
    data.certificate_sub_title = 'Of Achievement'
    data.before_name = 'This is to certify that'
    data.after_name_1 = 'has successfully completed the course on'
    data.after_name_3 = 'You are AWESOME!'

    switch (certificate_type) {
      case 'course_dsa':
        data.after_name_2 = 'Data Structures and Algorithms.'
        break
      case 'course_frontend':
        data.after_name_2 = 'Front-End Web Development.'
        break
      case 'course_backend':
        data.after_name_2 = 'Back-End Web Development.'
        break
      case 'course_dsa_frontend_backend':
        data.after_name_2 = 'DSA, Front-End and Back-End Web Development.'
        break
      case 'course_solana':
        data.after_name_1 = 'has successfully completed'
        data.after_name_2 = 'Solana Bootcamp.'
        break
      default:
        throw new TypeError('Invalid Certificate Type')
    }
  } else if (certificate_type.startsWith('community_')) {
    data.certificate_sub_title = 'Of Appreciation'
    data.before_name = 'This certificate of appreciation is awarded to'

    switch (certificate_type) {
      case 'community_batch_leader':
        data.after_name_1 = 'for showcasing extra ordinary leadership skills'
        data.after_name_2 = 'throughout the Devsnest course. Their contribution'
        data.after_name_3 =
          'is deeply valued by all the lives they have touched.'
        break
      case 'community_student_mentor':
        data.after_name_1 = 'for being an outstanding Student Mentor in the'
        data.after_name_2 = 'Devsnest Community. Their contribution is'
        data.after_name_3 = 'deeply valued by all the lives they have touched.'
        break
      case 'community_moderator':
        data.after_name_1 = 'for being an outstanding Community Moderator'
        data.after_name_2 = 'in the Devsnest Community. Their contribution'
        data.after_name_3 =
          'is deeply valued by all the lives they have touched.'
        break
      default:
        throw new TypeError('Invalid Certificate Type')
    }
  } else {
    throw new TypeError('Invalid Certificate Type')
  }

  return data
}

export const getCertificateBlobAndDataURL = async (
  svg: string
): Promise<BlobDataURLType> => {
  const canvas = document.createElement('canvas') as HTMLCanvasElement
  const ctx = canvas.getContext('2d')

  if (ctx) {
    try {
      const v = await Canvg.from(ctx, svg)

      await v.render()

      const blob = await canvasToBlob(canvas)

      if (!blob) {
        throw new Error('Error in generating certificate!')
      }

      return { blob, dataURL: canvas.toDataURL() }
    } catch (error) {
      logger('Error in certificates', error)
      throw new Error(ErrorMessage)
    }
  } else {
    throw new Error(ErrorMessage)
  }
}

const canvasToBlob = async (
  canvas: HTMLCanvasElement
): Promise<Blob | null> => {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob)
    })
  })
}
